/* eslint-disable import/no-cycle */
// actions
import { clearPlaces } from '../../Places/actions';
import {
  clearDirectionsAll,
  showDirectionsAltMap,
} from '../../Directions/actions';
import { deleteErrorMessages } from '../../ErrorMsg/actions';
import { updateSuperchargersRoutechargers } from '../../Superchargers/actions';

// helpers
import { makeActionCreator, clearFromURLHash } from '../../../lib/Utils';

export const STARTOVERBTN_UPDATE_LABEL = 'STARTOVERBTN_UPDATE_LABEL';
export const updateStartOverBtnLabel = makeActionCreator(
  STARTOVERBTN_UPDATE_LABEL,
  'label',
);

export function startOver() {
  // eslint-disable-next-line arrow-parens
  return dispatch => {
    dispatch(clearPlaces());
    dispatch(clearDirectionsAll());
    dispatch(deleteErrorMessages());
    dispatch(updateSuperchargersRoutechargers([]));
    dispatch(showDirectionsAltMap(false));
    clearFromURLHash();
  };
}
